import { 
    cloudinaryRes, 
    cloudinaryApi, 
    config, 
    getSignature,
    getTimestamp 
} from '../apis/cloudinary';

import { 
    SIGN_IN,
    SIGN_OUT,
    SET_SITE_KEY,
    FETCH_PICTURE_DATA,
    DELETE_PICTURE
 } from './types';

 
 export const signIn = (userId) => {
    return { type: SIGN_IN, payload: userId };
};

export const signOut = () => {
    return { type: SIGN_OUT, payload: null };
};

export const setSiteKey = siteKey => {
    return { type: SET_SITE_KEY, payload: siteKey }
}

// Get the date for the pictures including the URLS to use for the browsers
export const fetchPictureData = category => async (dispatch) => {
    const response =  await cloudinaryRes.get(`/list/${category}.json`).catch(error => {
      });
    if (response) {
        dispatch ({ type: FETCH_PICTURE_DATA, payload: response.data });
    } else {
        dispatch({ type: FETCH_PICTURE_DATA, payload: {resources: [] }});
    }
};

export const deletePicture = (publicId) => async (dispatch) => {
    const timestamp = getTimestamp();
    await cloudinaryApi.post('/image/destroy', {
        public_id: publicId,
        timestamp: timestamp,
        api_key: config.apiKey,
        signature: getSignature(`public_id=${publicId}`, timestamp)
    });
    dispatch ({ type: DELETE_PICTURE, payload: publicId });
}